import { render } from "./LeadsSvg.vue?vue&type=template&id=7ae8449c"
const script = {}
script.render = render

export default script